import { render, staticRenderFns } from "./LectureLessonImageDocument.vue?vue&type=template&id=68c4e63b&"
import script from "./LectureLessonImageDocument.vue?vue&type=script&lang=js&"
export * from "./LectureLessonImageDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports